export var CustomVariables;
(function (CustomVariables) {
    CustomVariables["ObjectPageSectionTitleFontFamily"] = "--ui5wcr_ObjectPage_SectionTitleFontFamily";
    CustomVariables["ObjectPageSectionBorderTop"] = "--ui5wcr_ObjectPage_SectionBorderTop";
    CustomVariables["ObjectPageSubSectionBackgroundColor"] = "--ui5wcr_ObjectPage_SubSectionBackgroundColor";
    CustomVariables["ObjectPageSubSectionBorderRadius"] = "--ui5wcr_ObjectPage_SubSectionBorderRadius";
})(CustomVariables || (CustomVariables = {}));
export const CustomThemingParameters = new Proxy(CustomVariables, {
    // @ts-ignore
    get: (target, prop) => `var(${target[prop]})`
});
